import { RouteRecordRaw } from 'vue-router'

import { AlliancesOriginKeyword } from '@/micro/types/register.type'

interface Props {
  partner: AlliancesOriginKeyword
}

const alliancesRegisterRoutes: Array<RouteRecordRaw> = [
  {
    path: '/user/register/alianza/ccb',
    name: 'register-ccb',
    component: () => import('@/micro/views/alliance-register/AllianceRegisterView.vue'),
    props: {
      partner: 'partner-ccb',
    } as Props,
  },
  {
    path: '/user/register/alianza/nequi',
    name: 'register-nequi',
    component: () => import('@/micro/views/alliance-register/AllianceRegisterView.vue'),
    props: {
      partner: 'partner-nequi',
    } as Props,
  },
  {
    path: '/user/register/alianza/payu',
    name: 'register-payu',
    component: () => import('@/micro/views/alliance-register/AllianceRegisterView.vue'),
    props: {
      partner: 'partner-payu',
    } as Props,
  },
  {
    path: '/user/register/alianza/payu-mex',
    name: 'register-payu-mex',
    component: () => import('@/micro/views/alliance-register/AllianceRegisterView.vue'),
    props: {
      partner: 'partner-payu-mex',
    } as Props,
  },
  {
    path: '/user/register/alianza/visa-per',
    name: 'register-visa-per',
    component: () => import('@/micro/views/alliance-register/AllianceRegisterView.vue'),
    props: {
      partner: 'partner-visa-per',
    } as Props,
  },
  {
    path: '/user/register/alianza/visa-col',
    name: 'register-visa-col',
    component: () => import('@/micro/views/alliance-register/AllianceRegisterView.vue'),
    props: {
      partner: 'partner-visa-col',
    } as Props,
  },
  {
    path: '/user/register/alianza/visa-dom',
    name: 'register-visa-dom',
    component: () => import('@/micro/views/alliance-register/AllianceRegisterView.vue'),
    props: {
      partner: 'partner-visa-dom',
    } as Props,
  },
  {
    path: '/user/register/alianza/visa-cri',
    name: 'register-visa-cri',
    component: () => import('@/micro/views/alliance-register/AllianceRegisterView.vue'),
    props: {
      partner: 'partner-visa-cri',
    } as Props,
  },
  {
    path: '/user/register/alianza/visa-mex',
    name: 'register-visa-mex',
    component: () => import('@/micro/views/alliance-register/AllianceRegisterView.vue'),
    props: {
      partner: 'partner-visa-mex',
    } as Props,
  },
  {
    path: '/user/register/alianza/mastercard-banreservas',
    name: 'register-mastercard-banreservas',
    component: () => import('@/micro/views/alliance-register/AllianceRegisterView.vue'),
    props: {
      partner: 'alzmasterc',
    } as Props,
  },
]

export default alliancesRegisterRoutes
